<template>
  <div>
    <v-main>
      <v-container>
        <v-row>
          <div style="width:100%">
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <!-- <v-card-text> -->
                  <v-container>
                    <v-row style="padding-top:15px;padding-bottom:15px">
                      <v-col style="padding: 15px 16px 0px">
                        <h2>แก้ไขข้อมูลร้าน</h2>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" >
                        <v-img
                          aspect-ratio="6"
                          contain
                          height="200"
                          :src="formUpdate.logoPreview"
                        ></v-img>
                        <br />
                        <v-file-input
                          required
                          counter
                          show-size
                          accept="image/png, image/jpeg, image/bmp"
                          prepend-icon="mdi-camera"
                          label="โลโก้ร้าน"
                          @change="selectImgShop"
                          v-model="filesShop"
                        ></v-file-input>
                      </v-col>
                    <!-- </v-row>
                    <v-row> -->
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                        <v-text-field
                            placeholder="ชื่อร้าน"
                            label="ชื่อร้าน"
                            outlined
                            dense
                            v-model="formUpdate.name"
                            :rules="[rules.required]"
                            required
                          ></v-text-field>
                      </v-col>
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                        <v-text-field
                            placeholder="เบอร์โทรศัพท์"
                            label="เบอร์โทรศัพท์"
                            outlined
                            dense
                            v-model="formUpdate.contactTel"
                            :rules="[rules.required, rules.numberRules]"
                            maxlength="10"
                            required
                          ></v-text-field>
                      </v-col>
                    <!-- </v-row>
                    <v-row> -->
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                         <v-text-field
                            placeholder="E-mail"
                            label="E-mail"
                            outlined
                            dense
                            v-model="formUpdate.contactEmail"
                            type="email"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                        <v-text-field
                            placeholder="Website"
                            label="Website"
                            outlined
                            dense
                            v-model="formUpdate.WebsiteShop"
                          ></v-text-field>
                      </v-col>
                    <!-- </v-row>
                    <v-row> -->
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                         <v-text-field
                            placeholder="Facebook"
                            label="Facebook"
                            outlined
                            dense
                            v-model="formUpdate.FacebookShop"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                        <v-text-field
                            placeholder="LINE"
                            label="LINE"
                            outlined
                            dense
                            v-model="formUpdate.LineShop"
                          ></v-text-field>
                      </v-col>
                    <!-- </v-row>
                    <v-row> -->
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                        <v-text-field
                            placeholder="Twitter"
                            label="Twitter"
                            outlined
                            dense
                            v-model="formUpdate.TwitterShop"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                        <v-text-field
                            placeholder="Instagram"
                            label="Instagram"
                            outlined
                            dense
                            v-model="formUpdate.InstagramShop"
                          ></v-text-field>
                      </v-col>
                    <!-- </v-row>
                    <v-row> -->
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                        <v-text-field
                            placeholder="Youtube"
                            label="Youtube"
                            outlined
                            dense
                            v-model="formUpdate.YoutuberShop"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                        <v-text-field
                            placeholder="TikTok"
                            label="TikTok"
                            outlined
                            dense
                            v-model="formUpdate.TikTokShop"
                          ></v-text-field>
                      </v-col>
                    <!-- </v-row>
                    <v-row> -->
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                         <v-text-field
                            placeholder="แผนที่"
                            label="แผนที่"
                            outlined
                            dense
                            v-model="formUpdate.map"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                        <v-select
                            placeholder="ช่วงคะแนนหมดอายุ"
                            label="ช่วงคะแนนหมดอายุ"
                            outlined
                            dense
                            v-model="formUpdate.monthExpire"
                            :items="selectItem"
                            item-text="text"
                            item-value="value"
                          ></v-select>
                      </v-col>
                    <!-- </v-row>

                    <v-row> -->
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                          <v-text-field
                            placeholder="รายละเอียดที่อยู่"
                            label="รายละเอียดที่อยู่"
                            outlined
                            dense
                            v-model="formUpdate.detailAddress"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                          <v-text-field
                            placeholder="รหัสไปรษณีย์"
                            label="รหัสไปรษณีย์"
                            outlined
                            dense
                            v-model="formUpdate.postalCode"
                            @change="addAddress()"
                          ></v-text-field>
                      </v-col>
                    <!-- </v-row>

                    <v-row> -->
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                          <v-select
                            placeholder="ตำบล/แขวง"
                            label="ตำบล/แขวง"
                            outlined
                            dense
                            v-model="formUpdate.subDistrict"
                            :items="optionSubDistrict"
                          ></v-select>
                      </v-col>
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                          <v-select
                            placeholder="อำเภอ/เขต"
                            label="อำเภอ/เขต"
                            outlined
                            dense
                            v-model="formUpdate.district"
                            :items="optionDistrict"
                          ></v-select>
                      </v-col>
                    <!-- </v-row>

                    <v-row> -->
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                          <v-select
                            placeholder="จังหวัด"
                            label="จังหวัด"
                            outlined
                            dense
                            v-model="formUpdate.provinces"
                            :items="optionProvinces"
                          ></v-select>
                      </v-col>
                      <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="height:80px">
                          <v-select
                            placeholder="รูปแบบการชำระเงิน"
                            label="รูปแบบการชำระเงิน"
                            outlined
                            dense
                            v-model="formUpdate.showPromtPay"
                            :items="payment"
                          ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-btn
                      color="#173053"
                      dark
                      block
                      :disabled="!validUpdate"
                      :loading="loadingEdit"
                      @click="editData()"
                    >
                      บันทึก
                    </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
              </v-form>
            </div>
        </v-row>
      </v-container>

    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/only_shop/', // Path Model
      returnLink: '/system/EditShop',
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'SYS_GROUP_TYPE_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogLink: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      formUpdate: {
        logo: '',
        logoPreview: '',
        contactTel: '',
        name: '',
        expireDate: '',
        contactEmail: '',
        WebsiteShop: '',
        FacebookShop: '',
        LineShop: '',
        TwitterShop: '',
        InstagramShop: '',
        YoutuberShop: '',
        TikTokShop: '',
        map: '',
        pictureUrl: '',
        pictureUrlPreview: '',
        flexPicHomePage: '',
        flexPicHomePagePreview: '',
        flexPicMembercardPage: '',
        flexPicMembercardPagePreview: '',
        monthExpire: '12',
        postalCode: '',
        district: '',
        subDistrict: '',
        detailAddress: '',
        provinces: '',
        showPromtPay: ''
      },
      selectItem: [
        { text: '1 เดือน', value: '1' },
        { text: '3 เดือน', value: '3' },
        { text: '4 เดือน', value: '4' },
        { text: '1 ปี', value: '12' },
        { text: '2 ปี', value: '24' },
        { text: '3 ปี', value: '36' }
      ],
      filesShop: null,
      flexPicHomePage: null,
      flexPicMembercardPage: null,
      filesUpdate: null,
      rules: {
        required: value => !!value || 'กรุณากรอก.'
      },
      validUpdate: true,
      resZipCode: [],
      optionDistrict: [],
      optionSubDistrict: [],
      optionProvinces: [],
      loadingEdit: false,
      LinkPath: '',
      payment: [
        {text: 'นิติบุคคล', value: 'False'},
        {text: 'พร้อมเพย์', value: 'True'}
      ]
      // End Data Table Config
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    this.dataReady = false
    await this.getDataById()
    await this.addAddress()
    // Get Data
    await this.getData()
    await this.setExpri()
  },
  methods: {
    getData () {
      this.dataReady = true
      axios
        .get(this.DNS_IP + '/only_shop/get?shopId=' + this.session.data.shopId)
        .then(res => {
          Object.assign(this.formUpdate, res.data[0])
          //   this.formUpdate = res.data[0]
          this.dataItem = res.data
          console.log('this.formUpdate', this.formUpdate)
        })
    },
    copyTextformUpdate () {
      let textToCopyformUpdate = this.$refs.textToCopyformUpdate.$el.querySelector(
        'input'
      )
      textToCopyformUpdate.select()
      document.execCommand('copy')
    },
    Link () {
      this.LinkPath =
        'https://liff.line.me/1656906322-JN5MM8Ep/home?shopId=' +
        this.$session.getAll().data.shopId +
        '&type=welcome'
    },
    async setExpri () {
      console.log('data', this.dataItem)
      let month = this.dataItem
      this.dataItem = []
      for (let i = 0; i < month.length; i++) {
        let d = month[i]
        if (d.monthExpire !== '') {
          if (d.monthExpire === '12') {
            d.monthExpiredate = '1 ปี'
            console.log(d.monthExpiredate)
            this.dataItem.push(d)
          } else if (d.monthExpire === '24') {
            d.monthExpiredate = '2 ปี'
            this.dataItem.push(d)
            console.log(d.monthExpiredate)
          } else if (d.monthExpire === '36') {
            d.monthExpiredate = '3 ปี'
            this.dataItem.push(d)
            console.log(d.monthExpiredate)
          } else {
            d.monthExpiredate = d.monthExpire + ' เดือน'
            console.log(d.monthExpiredate)
            this.dataItem.push(d)
          }
        } else {
          d.packageExpridate = ''
          this.dataItem.push(d)
        }
      }
    },
    async addAddress () {
      console.log('111', this.formUpdate.postalCode)
      // if (this.formUpdate.postalCode.length === 5) {
      this.optionDistrict = []
      this.optionSubDistrict = []
      this.optionProvinces = []
      await axios
        .get(
          'https://api-belinked.betaskthai.tech/location/map_thai?zipcode=' +
              this.formUpdate.postalCode
        )
        .then(async response => {
          console.log(response.data.length > 0)
          this.resZipCode = response.data
          console.log('this.resZipCode', this.resZipCode)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var x = rs[i]
            var z = {}
            z.text = x.district
            z.value = x.district
            this.optionDistrict.push(z)

            var d = rs[i]
            var s = {}
            s.text = d.sub_district
            s.value = d.sub_district
            this.optionSubDistrict.push(s)
          }
          for (var t = 0; t < rs.length; t++) {
            var k = rs[t]
            var l = {}
            l.text = k.province
            l.value = k.province
            this.optionProvinces.push(l)
          }
        })
        .catch(error => {
          console.log(error)
        })
      // }
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    selectImgShop () {
      if (this.filesShop) {
        this.formUpdate.logoPreview = URL.createObjectURL(this.filesShop)
        console.log('ddddrrr', this.formUpdate.logoPreview)
      } else {
        this.formUpdate.logoPreview = ''
      }
    },
    selectImgUpdate (event) {
      if (this.filesUpdate != null) {
        this.formUpdate.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate
        )
      } else {
        this.formUpdate.pictureUrlPreview = ''
      }
    },
    selectImgHomePage (event) {
      if (this.flexPicHomePage != null) {
        this.formUpdate.flexPicHomePagePreview = URL.createObjectURL(
          this.flexPicHomePage
        )
      } else {
        this.formUpdate.flexPicHomePagePreview = ''
      }
    },
    selectImgMemberCard (event) {
      if (this.flexPicMembercardPage != null) {
        this.formUpdate.flexPicMembercardPagePreview = URL.createObjectURL(
          this.flexPicMembercardPage
        )
      } else {
        this.formUpdate.flexPicMembercardPagePreview = ''
      }
    },
    async getDataById () {
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'shopId',
        this.$session.getAll().data.shopId,
        this.returnLink
      )
      this.formUpdate.monthExpire = this.formUpdate.monthExpire
      this.formUpdate.logoPreview = this.formUpdate.logo
      this.formUpdate.pictureUrlPreview = this.formUpdate.pictureUrl
      this.formUpdate.flexPicHomePagePreview = this.formUpdate.flexPicHomePage
      this.formUpdate.flexPicMembercardPagePreview = this.formUpdate.flexPicMembercardPage
      this.formUpdate.expireDate = moment(this.formUpdate.expireDate).format(
        'YYYY-MM-DD HH:mm'
      )
    },
    async editData () {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.shopId
          if (this.filesShop) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesShop)

            await axios
              .post(this.DNS_IP + `/file/upload/reward`, params)
              .then(function (response) {
                _this.formUpdate.logo = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.logo = this.formUpdate.logoPreview
          }
          if (this.filesUpdate) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesUpdate)

            await axios
              .post(this.DNS_IP + `/file/upload/reward`, params)
              .then(function (response) {
                _this.formUpdate.pictureUrl = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.pictureUrl = this.formUpdate.pictureUrlPreview
          }
          if (this.flexPicHomePage) {
            const _this = this
            let params = new FormData()
            params.append('file', this.flexPicHomePage)

            await axios
              .post(this.DNS_IP + `/file/upload/reward`, params)
              .then(function (response) {
                _this.formUpdate.flexPicHomePage = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.flexPicHomePage = this.formUpdate.flexPicHomePagelPreview
          }
          if (this.flexPicMembercardPage) {
            const _this = this
            let params = new FormData()
            params.append('file', this.flexPicMembercardPage)

            await axios
              .post(this.DNS_IP + `/file/upload/reward`, params)
              .then(function (response) {
                _this.formUpdate.flexPicMembercardPage = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.flexPicMembercardPage = this.formUpdate.flexPicMembercardPagePreview
          }
          delete this.formUpdate['pictureUrlPreview']
          delete this.formUpdate['logoPreview']
          delete this.formUpdate['shopId']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          delete this.formUpdate['expireDate']
          delete this.formUpdate['flexPicMembercardPagePreview']
          delete this.formUpdate['flexPicHomePagePreview']
          console.log('this.formUpdate', this.formUpdate)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'edit/' + ID,
              this.formUpdate
              // {
              //   headers: {
              //     'Application-Key': this.$session.getAll().ApplicationKey
              //   }
              // }
            )
            .then(async response => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              // await this.reloadData()
              await this.clearDataUpdate()
              this.filesShop = null
              this.filesUpdate = null
              this.flexPicHomePage = null
              this.flexPicMembercardPage = null
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              await this.setExpri()
              this.loadingEdit = false
              this.getData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async clearDataUpdate () {
      // eslint-disable-next-line no-redeclare
      for (var key in this.formUpdate) {
        if (this.formUpdate[key]) {
          this.formUpdate[key] = ''
        }
      }
    }
  }
}
</script>
<style scope>
/* .v-text-field {
    padding: 0px 0px!important;
} */
</style>



// WEBPACK FOOTER //
// src/components/System/EditShop.vue